import {EventEmitter} from "./EventEmitter";

/**
 * Класс для работы с свг планами секторов, стадионов, сцен ...
 * инициализирует интерактивность и предоставляет события (click, hover ...)
 */
export class InteractPlan {
	/**
	 * В конструктор можем передавать параметры для интерактива
	 * тогда инициализация произойдет сразу, также можно вызывать через init
	 * @param params {Object} - Параметры интерактива: {
	 *   svg,
	 *   addViewBox {Boolean},
	 *   dragging {Boolean},
	 *   addControls {Boolean},
	 * }
	 */
	constructor(params = {}) {
		this.svg = null;
		this.interact = null;
		this.gestureArea = null;
		this.interactEmitter = new EventEmitter();

		/* Свойства (состояния) для плана */
		this.svgState = {
			x: 0,
			y: 0,
		};

		this.svgScale = 1;

		/* Если передать параметры при объявлении то инциализировать интерактивность */
		if (this.isValidParams(params)) this.init(params);
	}

	/**
	 * Инициализация интерактива
	 * @param params {Object} - Параметры (описание в конструкторе)
	 */
	init(params) {
		if (!this.isValidParams(params))
			throw new Error("Не удалось получить параметры интерактива!");

		this.svg = this.getSvgFromParams(params);
		this.gestureArea = document.getElementById("js-change-svg");
		this.scaleElement = this.gestureArea.querySelector("svg");
		if (!this.svg) throw new Error("Не удалось получить SVG!");

		this.interact = interact(this.svg);

		/* Инициализация доп параметров */
		if (params.addViewBox !== false) this.setViewBox();
		if (params.dragging !== false) this.initDragging();
		if (params.addControls !== false) this.initControls();

		this.initTapping();
		this.initHovering();
	}

	isValidParams(params) {
		if (!(typeof params === "object" && params !== null)) return false;
		if (!params.svg && !params.length > 0) return false;

		return true;
	}

	getSvgFromParams(params) {
		if (params.svg && params.svg.length > 0) return params.svg[0];
		if ($.contains(document, params[0])) return params[0];

		return null;
	}

	/* Listeners */
	on(action, fn) {
		if (action === "tap") {
			this.interactEmitter.subscribe("event:tap-on-plan", target => {
				fn(target);
			});
		}
		if (action === "hover") {
			this.interactEmitter.subscribe("event:hover-on-plan", target => {
				fn(target);
			});
		}
	}

	/* Инициализация базового интерактива */
	initDragging() {
		const scaleElement = this.scaleElement;
		const that = this;

		interact(this.gestureArea)
			.gesturable({
				listeners: {
					move(event) {
						const currentScale = event.scale * that.svgScale;

						that.gestureArea.style.transform = `scale(${currentScale})`;

						that.dragMoveListener.bind(that, event);
					},
					end(event) {
						that.svgScale = event.scale * that.svgScale;
					},
				},
			})
			.draggable({
				listeners: {move: that.dragMoveListener.bind(that)},
			});
	}

	dragMoveListener(event) {
		// const target = event.target;
		const target = this.gestureArea.querySelector("svg");

		// keep the dragged position in the data-x/data-y attributes
		this.svgState.x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
		this.svgState.y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

		// translate the element
		target.style.transform = `translate(${this.svgState.x}px, ${this.svgState.y}px)`;

		// update the posiion attributes
		target.setAttribute("data-x", this.svgState.x);
		target.setAttribute("data-y", this.svgState.y);
	}

	initControls() {
		$("#js-plan-zoom-in").on("click", () => {
			this.svgScale += 0.2;
			this.gestureArea.style.transform = `scale(${this.svgScale})`;
		});
		$("#js-plan-zoom-out").on("click", () => {
			this.svgScale -= 0.2;
			if (this.svgScale <= 0.5) this.svgScale = 0.5;
			this.gestureArea.style.transform = `scale(${this.svgScale})`;
		});
		$("#js-plan-zoom-reset").on("click", () => {
			this.svgState.x = 0;
			this.svgState.y = 0;
			this.svgScale = 1;
			this.gestureArea.style.transform = `scale(1)`;

			this.updateTransformOfPlan();
		});
	}

	initHovering() {
		$(this.svg.parentNode).on("mouseover", e => {
			this.interactEmitter.emit("event:hover-on-plan", $(e.target));
		});
	}

	initTapping() {
		this.interact.on("tap", event => {
			if (event.which === 3) return false;

			this.interactEmitter.emit("event:tap-on-plan", $(event.target));

			event.stopPropagation();
			event.stopImmediatePropagation();
			event.preventDefault();
		});
	}

	updateTransformOfPlan(event) {
		this.scaleElement.setAttribute("data-x", this.svgState.x);
		this.scaleElement.setAttribute("data-y", this.svgState.y);

		return (this.svg.style.webkitTransform = this.svg.style.transform =
			"translate(" + this.svgState.x + "px, " + this.svgState.y + "px)");
	}

	resetTransform() {
		this.svgState.x = 0;
		this.svgState.y = 0;
		this.svgScale = 1;
		this.gestureArea.style.transform = `scale(1)`;

		this.updateTransformOfPlan();
	}

	/** Адаптирует план добавив новый атрибут */
	setViewBox() {
		if ($(this.svg).attr("viewBox")) return true;

		return $(this.svg).attr(
			"viewBox",
			`0 0 ${$(this.svg).attr("width")} ${$(this.svg).attr("height")}`
		);
	}
}
